import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-05',
  templateUrl: './dpto05.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto05Component extends DepartmentBase {
  municipalities = [{
    "id": 1,
    "code": "05001",
    "name": "Medell\u00edn",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 2,
    "code": "05002",
    "name": "Abejorral",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 3,
    "code": "05004",
    "name": "Abriaqu\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 4,
    "code": "05021",
    "name": "Alejandr\u00eda",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 5,
    "code": "05030",
    "name": "Amag\u00e1",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 6,
    "code": "05031",
    "name": "Amalfi",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 7,
    "code": "05034",
    "name": "Andes",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 8,
    "code": "05036",
    "name": "Angel\u00f3polis",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 9,
    "code": "05038",
    "name": "Angostura",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 10,
    "code": "05040",
    "name": "Anor\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 11,
    "code": "05042",
    "name": "Santaf\u00e9 de Antioquia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 12,
    "code": "05044",
    "name": "Anza",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 13,
    "code": "05045",
    "name": "Apartad\u00f3",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 14,
    "code": "05051",
    "name": "Arboletes",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 15,
    "code": "05055",
    "name": "Argelia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 16,
    "code": "05059",
    "name": "Armenia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 17,
    "code": "05079",
    "name": "Barbosa",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 18,
    "code": "05086",
    "name": "Belmira",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 19,
    "code": "05088",
    "name": "Bello",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 20,
    "code": "05091",
    "name": "Betania",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 21,
    "code": "05093",
    "name": "Betulia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 22,
    "code": "05101",
    "name": "Ciudad Bol\u00edvar",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 23,
    "code": "05107",
    "name": "Brice\u00f1o",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 24,
    "code": "05113",
    "name": "Buritic\u00e1",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 25,
    "code": "05120",
    "name": "C\u00e1ceres",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 26,
    "code": "05125",
    "name": "Caicedo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 27,
    "code": "05129",
    "name": "Caldas",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 28,
    "code": "05134",
    "name": "Campamento",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 29,
    "code": "05138",
    "name": "Ca\u00f1asgordas",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 30,
    "code": "05142",
    "name": "Caracol\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 31,
    "code": "05145",
    "name": "Caramanta",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 32,
    "code": "05147",
    "name": "Carepa",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 33,
    "code": "05148",
    "name": "El Carmen de Viboral",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 34,
    "code": "05150",
    "name": "Carolina",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 35,
    "code": "05154",
    "name": "Caucasia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 36,
    "code": "05172",
    "name": "Chigorod\u00f3",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 37,
    "code": "05190",
    "name": "Cisneros",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 38,
    "code": "05197",
    "name": "Cocorn\u00e1",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 39,
    "code": "05206",
    "name": "Concepci\u00f3n",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 40,
    "code": "05209",
    "name": "Concordia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 41,
    "code": "05212",
    "name": "Copacabana",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 42,
    "code": "05234",
    "name": "Dabeiba",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 43,
    "code": "05237",
    "name": "Don Mat\u00edas",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 44,
    "code": "05240",
    "name": "Eb\u00e9jico",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 45,
    "code": "05250",
    "name": "El Bagre",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 46,
    "code": "05264",
    "name": "Entrerrios",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 47,
    "code": "05266",
    "name": "Envigado",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 48,
    "code": "05282",
    "name": "Fredonia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 49,
    "code": "05284",
    "name": "Frontino",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 50,
    "code": "05306",
    "name": "Giraldo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 51,
    "code": "05308",
    "name": "Girardota",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 52,
    "code": "05310",
    "name": "G\u00f3mez Plata",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 53,
    "code": "05313",
    "name": "Granada",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 54,
    "code": "05315",
    "name": "Guadalupe",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 55,
    "code": "05318",
    "name": "Guarne",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 56,
    "code": "05321",
    "name": "Guatap\u00e9",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 57,
    "code": "05347",
    "name": "Heliconia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 58,
    "code": "05353",
    "name": "Hispania",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 59,
    "code": "05360",
    "name": "Itagui",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 60,
    "code": "05361",
    "name": "Ituango",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 61,
    "code": "05364",
    "name": "Jard\u00edn",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 62,
    "code": "05368",
    "name": "Jeric\u00f3",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 63,
    "code": "05376",
    "name": "La Ceja",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 64,
    "code": "05380",
    "name": "La Estrella",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 65,
    "code": "05390",
    "name": "La Pintada",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 66,
    "code": "05400",
    "name": "La Uni\u00f3n",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 67,
    "code": "05411",
    "name": "Liborina",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 68,
    "code": "05425",
    "name": "Maceo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 69,
    "code": "05440",
    "name": "Marinilla",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 70,
    "code": "05467",
    "name": "Montebello",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 71,
    "code": "05475",
    "name": "Murind\u00f3",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 72,
    "code": "05480",
    "name": "Mutat\u00e1",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 73,
    "code": "05483",
    "name": "Nari\u00f1o",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 74,
    "code": "05490",
    "name": "Necocl\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 75,
    "code": "05495",
    "name": "Nech\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 76,
    "code": "05501",
    "name": "Olaya",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 77,
    "code": "05541",
    "name": "Pe\u00f1ol",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 78,
    "code": "05543",
    "name": "Peque",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 79,
    "code": "05576",
    "name": "Pueblorrico",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 80,
    "code": "05579",
    "name": "Puerto Berr\u00edo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 81,
    "code": "05585",
    "name": "Puerto Nare",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 82,
    "code": "05591",
    "name": "Puerto Triunfo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 83,
    "code": "05604",
    "name": "Remedios",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 84,
    "code": "05607",
    "name": "Retiro",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 85,
    "code": "05615",
    "name": "Rionegro",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 86,
    "code": "05628",
    "name": "Sabanalarga",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 87,
    "code": "05631",
    "name": "Sabaneta",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 88,
    "code": "05642",
    "name": "Salgar",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 89,
    "code": "05647",
    "name": "San Andr\u00e9s de Cuerqu\u00eda",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 90,
    "code": "05649",
    "name": "San Carlos",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 91,
    "code": "05652",
    "name": "San Francisco",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 92,
    "code": "05656",
    "name": "San Jer\u00f3nimo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 93,
    "code": "05658",
    "name": "San Jos\u00e9 de La Monta\u00f1a",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 94,
    "code": "05659",
    "name": "San Juan de Urab\u00e1",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 95,
    "code": "05660",
    "name": "San Luis",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 96,
    "code": "05664",
    "name": "San Pedro",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 97,
    "code": "05665",
    "name": "San Pedro de Uraba",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 98,
    "code": "05667",
    "name": "San Rafael",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 99,
    "code": "05670",
    "name": "San Roque",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 100,
    "code": "05674",
    "name": "San Vicente",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 101,
    "code": "05679",
    "name": "Santa B\u00e1rbara",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 102,
    "code": "05686",
    "name": "Santa Rosa de Osos",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 103,
    "code": "05690",
    "name": "Santo Domingo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 104,
    "code": "05697",
    "name": "El Santuario",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 105,
    "code": "05736",
    "name": "Segovia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 106,
    "code": "05756",
    "name": "Sonson",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 107,
    "code": "05761",
    "name": "Sopetr\u00e1n",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 108,
    "code": "05789",
    "name": "T\u00e1mesis",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 109,
    "code": "05790",
    "name": "Taraz\u00e1",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 110,
    "code": "05792",
    "name": "Tarso",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 111,
    "code": "05809",
    "name": "Titirib\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 112,
    "code": "05819",
    "name": "Toledo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 113,
    "code": "05837",
    "name": "Turbo",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 114,
    "code": "05842",
    "name": "Uramita",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 115,
    "code": "05847",
    "name": "Urrao",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 116,
    "code": "05854",
    "name": "Valdivia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 117,
    "code": "05856",
    "name": "Valpara\u00edso",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 118,
    "code": "05858",
    "name": "Vegach\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 119,
    "code": "05861",
    "name": "Venecia",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 120,
    "code": "05873",
    "name": "Vig\u00eda del Fuerte",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 121,
    "code": "05885",
    "name": "Yal\u00ed",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 122,
    "code": "05887",
    "name": "Yarumal",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 123,
    "code": "05890",
    "name": "Yolomb\u00f3",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 124,
    "code": "05893",
    "name": "Yond\u00f3",
    "state": "1",
    "department_code": "5"
  }, {
    "id": 125,
    "code": "05895",
    "name": "Zaragoza",
    "state": "1",
    "department_code": "5"
  }]
}
